import { Avatar, type AvatarProps } from '@mui/material'
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined'

interface IntegrationIconProps extends Omit<AvatarProps, 'src' | 'children'> {
  iconUrl?: string | null
  size?: number
}

/** An integration catalog entry's icon, falling back to a generic
 *  puzzle-piece vector icon when no custom one has been set (see
 *  `IntegrationCatalogEntry.icon_url` — null means "use the default"). */
export function IntegrationIcon({ iconUrl, size = 32, sx, ...rest }: IntegrationIconProps) {
  return (
    <Avatar
      src={iconUrl ?? undefined}
      variant="rounded"
      sx={{
        width: size, height: size, borderRadius: 1.5,
        bgcolor: iconUrl ? 'transparent' : 'action.hover',
        color: 'text.secondary',
        '& img': { objectFit: 'contain' },
        ...sx,
      }}
      {...rest}
    >
      <ExtensionOutlinedIcon sx={{ fontSize: size * 0.55 }} />
    </Avatar>
  )
}
